import { Button } from 'components/Button/Button';
import { ContentBlock } from 'components/ContentBlock/ContentBlock';
import { Formik } from 'formik';

import { CreateUserProjectRequestPayload } from 'services/person/request/request.types';

import usePersonProjectRequestFormVM from './usePersonProjectRequestFormVM';
import TipTap from 'components/TipTap/TipTap';
export function PersonProjectRequestForm() {
    const { handleFormSubmit, isEdit, request, projectId, isLoading } = usePersonProjectRequestFormVM();

    return (
        <>
            <Formik
                initialValues={{
                    projectId: (isEdit && request && projectId != null) ? parseInt(projectId) : 0,
                    label: (isEdit && request) ? request.label : '',
                    observation: (isEdit && request) ? request.observation : '',
                }}
                enableReinitialize
                onSubmit={async (values: CreateUserProjectRequestPayload, { setSubmitting }) => {
                    handleFormSubmit(values);
                    setSubmitting(false);
                }}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => {
                    return (
                        <form onSubmit={handleSubmit} className="form">
                            {/* <FormikDebug values={values} /> */}
                            <ContentBlock title="Détail de la demande" isLoading={isLoading}>
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Intitulé</label>
                                        <input
                                            type="text"
                                            name="label"
                                            placeholder="Nom de la demande"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.label}
                                            required
                                        />
                                        {errors.label && touched.label && errors.label}
                                    </div>
                                </div>
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Description</label>
                                        <div className="wysiwyg-container">
                                            <TipTap
                                                name="observation"
                                                value={values.observation}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                        {errors.observation && touched.observation && errors.observation}
                                    </div>
                                </div>
                                <Button type="submit" label={isEdit ? "Modifier la demande" : "Ajouter la demande"} />
                            </ContentBlock>
                        </form>
                    );
                }}
            </Formik>
        </>
    );
}
